import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'
import { NullValue } from './NullValue'

interface Props {
  isNull?: (value: number) => boolean
  children: number
}

function defaultIsNull(value: number) {
  return value === 0
}

export function CurrencyValue(props: Props) {
  const { children, isNull = defaultIsNull } = props
  const { currency, language } = useSelector(selectUserConfiguration)

  const formattedValue = useMemo(
    () => new Intl.NumberFormat(language).format(children),
    [children, language],
  )

  return isNull(children) ? <NullValue /> : `${formattedValue} ${currency.toUpperCase()}`
}
